function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { forwardRef, useState } from "react";
import PropTypes from "prop-types";
import cc from "classcat";
import { twMerge } from "tailwind-merge";
import Label from "../Label";
import InputError from "./InputError";
import Spinner from "../Spinner";
import Tooltip from "../Tooltip/Tooltip";
import { InformationCircleIcon } from "@heroicons/react/24/outline";
import { ExclamationTriangleIcon } from "@heroicons/react/20/solid";
var Input = /*#__PURE__*/ forwardRef(function Input(_param, ref) {
    var _param_id = _param.id, id = _param_id === void 0 ? null : _param_id, name = _param.name, InputWrapperRef = _param.InputWrapperRef, label = _param.label, className = _param.className, _param_disabled = _param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, errorMessage = _param.errorMessage, inlineAddonLeft = _param.inlineAddonLeft, inlineAddonRight = _param.inlineAddonRight, AddonRightClassName = _param.AddonRightClassName, AddonLeftClassName = _param.AddonLeftClassName, loading = _param.loading, helperText = _param.helperText, tooltipContent = _param.tooltipContent, _onFocus = _param.onFocus, _onBlur = _param.onBlur, LabelClassName = _param.LabelClassName, _param_isTableInput = _param.isTableInput, isTableInput = _param_isTableInput === void 0 ? false : _param_isTableInput, efacturaCode = _param.efacturaCode, clearButton = _param.clearButton, onClear = _param.onClear, props = _object_without_properties(_param, [
        "id",
        "name",
        "InputWrapperRef",
        "label",
        "className",
        "disabled",
        "errorMessage",
        "inlineAddonLeft",
        "inlineAddonRight",
        "AddonRightClassName",
        "AddonLeftClassName",
        "loading",
        "helperText",
        "tooltipContent",
        "onFocus",
        "onBlur",
        "LabelClassName",
        "isTableInput",
        "efacturaCode",
        "clearButton",
        "onClear"
    ]);
    if (!!clearButton && (!onClear || typeof onClear !== "function")) {
        throw new Error("Input should always receive a onClear function(if it has clearButton), received onClear= ".concat(onClear));
    }
    var _useState = _sliced_to_array(useState(false), 2), isFocused = _useState[0], setIsFocused = _useState[1];
    function onFocus(e) {
        setIsFocused(true);
        _onFocus && _onFocus(e);
    }
    function onBlur(e) {
        var _e_relatedTarget;
        (_e_relatedTarget = e.relatedTarget) === null || _e_relatedTarget === void 0 ? void 0 : _e_relatedTarget.focus();
        setIsFocused(false);
        _onBlur && _onBlur(e);
    }
    if (!id) {
        id = name;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: twMerge(cc([
            "flex w-full flex-col",
            {
                "gap-y-1": label
            },
            {
                "flex-row items-center": isTableInput
            },
            {
                "gap-x-1.5": isTableInput && errorMessage
            }
        ]))
    }, isTableInput && errorMessage && /*#__PURE__*/ React.createElement(Tooltip, {
        content: errorMessage
    }, /*#__PURE__*/ React.createElement(ExclamationTriangleIcon, {
        className: cc([
            "h-6 w-6 text-red-500",
            {
                "pointer-events-none text-transparent": !errorMessage
            }
        ])
    })), /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center gap-x-2"
    }, label && /*#__PURE__*/ React.createElement(Label, {
        className: twMerge(cc([
            "line-clamp-1 break-all text-sm dark:text-gray-200",
            {
                "p-1": !tooltipContent
            },
            LabelClassName
        ])),
        htmlFor: name
    }, label), tooltipContent && /*#__PURE__*/ React.createElement(Tooltip, {
        content: tooltipContent
    }, /*#__PURE__*/ React.createElement("div", {
        className: "py-1"
    }, /*#__PURE__*/ React.createElement(InformationCircleIcon, {
        className: "h-5 w-5 stroke-black dark:stroke-gray-200"
    })))), /*#__PURE__*/ React.createElement("div", {
        className: twMerge(cc([
            "group relative rounded-lg",
            {
                "is-focused": isFocused
            },
            {
                "w-full": isTableInput
            }
        ])),
        ref: InputWrapperRef
    }, !loading && inlineAddonLeft && /*#__PURE__*/ React.createElement("span", {
        className: twMerge(cc([
            "absolute left-0 top-1/2 flex -translate-y-1/2 items-center text-sm text-gray-500",
            AddonLeftClassName
        ]))
    }, inlineAddonLeft), /*#__PURE__*/ React.createElement("input", _object_spread({
        className: twMerge("text-inter block w-full rounded-lg border-gray-200 bg-gray-50 text-base text-black outline-none transition-all duration-100 placeholder:text-gray-400 focus:border-blue-500 focus:border-transparent dark:border-blue-750 dark:bg-blue-775 dark:text-gray-200", cc([
            {
                "hover:cursor-pointer": !disabled
            },
            {
                "text-gray-400 hover:cursor-not-allowed dark:text-gray-500": disabled
            },
            {
                "border-red-450 focus:border-red-300 focus:ring-0 dark:border-red-450 dark:focus:border-red-300 dark:focus:ring-0": errorMessage
            },
            {
                "p-2": !inlineAddonLeft || !inlineAddonRight
            },
            {
                "pr-10": loading || inlineAddonRight || clearButton
            },
            {
                "pl-10": inlineAddonLeft && !loading
            },
            {
                "pr-15": (loading || inlineAddonRight) && clearButton
            }
        ]), className),
        ref: ref,
        id: id || name,
        name: name,
        disabled: disabled,
        "aria-describedby": "".concat(id || name, "-error"),
        onFocus: onFocus,
        onBlur: onBlur
    }, props)), !!clearButton && !loading && /*#__PURE__*/ React.createElement("button", {
        type: "button",
        disabled: disabled,
        className: cc([
            "absolute right-0 top-1/2 flex -translate-y-1/2 items-center",
            "!text-gray-400 dark:!text-gray-500 outline-none",
            {
                "cursor-pointer dark:hover:!text-blue-550 dark:focus:!text-blue-550 hover:!text-blue-550 focus:!text-blue-550": !disabled
            },
            {
                "cursor-not-allowed dark:hover:!text-gray-500 dark:focus:!text-gray-500 hover:!text-gray-400 focus:!text-gray-400": disabled
            },
            {
                "mr-10": loading || inlineAddonRight
            },
            {
                "mr-4": !(loading || inlineAddonRight)
            }
        ]),
        onClick: function() {
            onClear();
        },
        "aria-label": "Clear"
    }, "\xd7"), loading && /*#__PURE__*/ React.createElement("div", {
        className: "pointer-events-none absolute right-0 top-1/2 flex -translate-y-1/2 items-center pr-2"
    }, /*#__PURE__*/ React.createElement(Spinner, {
        variant: "primary"
    })), !loading && inlineAddonRight && /*#__PURE__*/ React.createElement("span", {
        className: twMerge(cc([
            "absolute right-0 top-1/2 flex -translate-y-1/2 items-center text-sm text-gray-500",
            AddonRightClassName
        ]))
    }, inlineAddonRight)), !isTableInput && (helperText || errorMessage || efacturaCode) && /*#__PURE__*/ React.createElement("div", {
        className: "inline-flex flex-wrap gap-x-2"
    }, !errorMessage && !!efacturaCode && /*#__PURE__*/ React.createElement("span", {
        className: "text-xs dark:text-gray-300 text-gray-500 mt-1"
    }, efacturaCode, helperText && " - ", helperText && /*#__PURE__*/ React.createElement("span", {
        className: "text-xs text-gray-400 mt-1"
    }, helperText)), helperText && !errorMessage && !efacturaCode && /*#__PURE__*/ React.createElement("span", {
        className: "text-xs text-gray-400 mt-1"
    }, helperText), errorMessage && !isTableInput && /*#__PURE__*/ React.createElement("div", {
        className: "pt-1.5"
    }, /*#__PURE__*/ React.createElement(InputError, null, errorMessage))));
});
Input.propTypes = {
    id: PropTypes.string,
    name: PropTypes.string.isRequired,
    className: PropTypes.string,
    size: PropTypes.oneOf([
        "small",
        "medium",
        "large"
    ]),
    value: PropTypes.string,
    disabled: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.number
    ]),
    readOnly: PropTypes.bool,
    label: PropTypes.node,
    errorMessage: PropTypes.node,
    AddonRightClassName: PropTypes.string,
    AddonLeftClassName: PropTypes.string,
    inlineAddonRight: PropTypes.node,
    inlineAddonLeft: PropTypes.node,
    loading: PropTypes.bool,
    placeholder: PropTypes.string,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    helperText: PropTypes.node,
    tooltipContent: PropTypes.node,
    LabelClassName: PropTypes.string,
    isTableInput: PropTypes.bool,
    efacturaCode: PropTypes.string,
    clearButton: PropTypes.node,
    onClear: PropTypes.func,
    InputWrapperRef: PropTypes.oneOfType([
        PropTypes.func,
        // Or the instance of a DOM native element
        PropTypes.shape({
            current: PropTypes.instanceOf(Element)
        })
    ])
};
export default Input;
